const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRProgressVoidInverse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconR-progress-void-inverse",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconR-progress-void-inverse1",
    serifid: "iconR-progress-void-inverse"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15,1c7.727,0 14,6.273 14,14c-0,7.727 -6.273,14 -14,14c-7.727,-0 -14,-6.273 -14,-14c0,-7.727 6.273,-14 14,-14Zm0,2.181c6.523,-0 11.819,5.296 11.819,11.819c0,6.523 -5.296,11.819 -11.819,11.819c-6.523,0 -11.819,-5.296 -11.819,-11.819c-0,-6.523 5.296,-11.819 11.819,-11.819Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.36
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,7.364c-4.215,-0 -7.636,3.421 -7.636,7.636c-0,4.215 3.421,7.636 7.636,7.636c4.215,0 7.636,-3.421 7.636,-7.636c0,-4.215 -3.421,-7.636 -7.636,-7.636Zm4.655,4.505c0.603,0.895 0.955,1.972 0.955,3.131c0,3.096 -2.514,5.61 -5.61,5.61c-1.159,0 -2.236,-0.352 -3.131,-0.955l7.786,-7.786Zm-1.524,-1.524l-7.786,7.786c-0.603,-0.895 -0.955,-1.972 -0.955,-3.131c-0,-3.096 2.514,-5.61 5.61,-5.61c1.159,-0 2.236,0.352 3.131,0.955Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRProgressVoidInverse);
export default __webpack_public_path__ + "static/media/iconR-progress-void-inverse.89cfaacc80cbb300ba3e1859e5394bbb.svg";
export { ForwardRef as ReactComponent };